import { render, staticRenderFns } from "./main.vue?vue&type=template&id=29742f52&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=29742f52&prod&lang=scss&"
import style1 from "./main.vue?vue&type=style&index=1&id=29742f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29742f52",
  null
  
)

export default component.exports